
import { Component, Prop, Vue } from "vue-property-decorator";
import IconAdministration from "../common/icon/IconAdministration.vue";
import POptionBar from "@/components/look/POptionBar.vue";

@Component({
  name: "administration-header",
  components: {
    POptionBar,
    IconAdministration,
  },
})
export default class AdministrationHeader extends Vue {
  @Prop() title!: string;

  options: { text: string; pressed: boolean; data: string }[] = [];
  path = {
    users: "/administration/users",
    clients: "/administration/clients",
    subclients: "/administration/subclients",
    servicePoints: "/administration/servicepoints",
    countries: "/administration/countries",
  };

  constructor() {
    super();
  }

  currentPath(): string {
    return this.$router.currentRoute.path;
  }

  mounted(): void {
    if (this.$ability.can("read", "UsersPage")) {
      this.options.push({
        text: this.$t("tab.users") as string,
        pressed: this.currentPath().includes(this.path.users),
        data: this.path.users,
      });
    }
    if (this.$ability.can("read", "CountriesPage")) {
      this.options.push({
        text: this.$t("tab.countries") as string,
        pressed: this.currentPath().includes(this.path.countries),
        data: this.path.countries,
      });
    }
    if (this.$ability.can("read", "ClientsPage")) {
      this.options.push({
        text: this.$t("tab.clients") as string,
        pressed: this.currentPath().includes(this.path.clients),
        data: this.path.clients,
      });
    }
    if (this.$ability.can("read", "SubclientsPage")) {
      this.options.push({
        text: this.$t("tab.subclients") as string,
        pressed: this.currentPath().includes(this.path.subclients),
        data: this.path.subclients,
      });
    }
    if (this.$ability.can("read", "ServicepointsPage")) {
      this.options.push({
        text: this.$t("tab.servicepoints") as string,
        pressed: this.currentPath().includes(this.path.servicePoints),
        data: this.path.servicePoints,
      });
    }
  }

  redirect(data: string): void {
    this.$router.push(data);
  }
}
